import { QUERY_TABLES } from '@/helpers/constants';
import { getRandomNumber900000to999999 } from '@/helpers/utility';
import { executeQueryReturnRawResponse } from '@/helpers/request';

const buildQueryTableData = ({ tenantId, limit, offset, filters = {} }) => {
  const randomTenantId = getRandomNumber900000to999999();
  
  // Build filter conditions based on search filters
  const filterConditions = {
    tenant_id: [tenantId, randomTenantId],
  };

  // Add search filters if provided
  if (filters.timestamp) {
    // Use like_text for timestamp fields to cast to text before LIKE operation
    filterConditions.timestamp = { like_text: [`${filters.timestamp}`] };
  }
  if (filters.actor) {
    filterConditions.actor = { like: [`%${filters.actor}%`] };
  }
  if (filters.httpMethod) {
    filterConditions.http_method = { like: [`%${filters.httpMethod}%`] };
  }
  if (filters.url) {
    filterConditions.url = { like: [`%${filters.url}%`] };
  }
  if (filters.content) {
    filterConditions.content = { like: [`%${filters.content}%`] };
  }

  return {
    data: {
      fields: {
        id: ['select'],
        timestamp: ['select'],
        actor: ['select'],
        http_method: ['select'],
        url: ['select'],
        content: ['select'],
      },
      skip: offset,
      limit: limit,
    },
    filter: filterConditions,
    scale: {},
    evol: {},
    count: true,
    order: {
      timestamp: 'desc',
    },
    table_name: QUERY_TABLES.AUDIT_WRITE_LOGS,
  };
};

export const fetchAuditWriteLog = async payload => {
  const { tenantId, limit = 10, offset = 0, filters = {} } = payload;
  const request = buildQueryTableData({ tenantId, limit, offset, filters });
  return executeQueryReturnRawResponse(request);
};
